/*
 * Horizontal scrolling and in-place size filtering for the homepage family
 * rows. Presentation only — no cart, packing or inventory state is touched.
 */
(() => {
  "use strict";

  const reduceMotion = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

  document.querySelectorAll("[data-exact-piece-row]").forEach((row) => {
    const rail = row.querySelector("[data-row-rail]");
    if (!rail) return;

    const status = row.querySelector("[data-row-status]");
    // Preview and demo specimens are filtered alongside real ones. They carry
    // the same `data-size`, but not the cart-wired card's own hook.
    const cards = [...row.querySelectorAll("[data-cork-product-card], [data-demo-specimen], [data-placeholder-specimen]")];
    const heading = row.querySelector("h2")?.textContent.trim() || "pieces";

    const scroll = (direction) => {
      const amount = Math.max(280, rail.clientWidth * 0.78) * direction;
      rail.scrollBy({ left: amount, behavior: reduceMotion() ? "auto" : "smooth" });
    };

    row.querySelector("[data-row-previous]")?.addEventListener("click", () => scroll(-1));
    row.querySelector("[data-row-next]")?.addEventListener("click", () => scroll(1));

    row.querySelectorAll("[data-row-size]").forEach((button) => {
      button.addEventListener("click", () => {
        const selected = button.dataset.rowSize || "all";
        row.querySelectorAll("[data-row-size]").forEach((choice) => {
          choice.setAttribute("aria-pressed", String(choice === button));
        });

        let visible = 0;
        cards.forEach((card) => {
          const show = selected === "all" || card.dataset.size === selected;
          card.closest('[role="listitem"]').hidden = !show;
          if (show) visible += 1;
        });

        rail.scrollTo({ left: 0, behavior: "auto" });
        if (status) {
          status.textContent = visible
            ? `${visible} ${heading} shown.`
            : `No ${button.textContent.trim()} ${heading} are catalogued yet.`;
        }
      });
    });

    rail.addEventListener("keydown", (event) => {
      if (event.key === "ArrowRight") { event.preventDefault(); scroll(1); }
      if (event.key === "ArrowLeft") { event.preventDefault(); scroll(-1); }
      if (event.key === "Home") { event.preventDefault(); rail.scrollTo({ left: 0, behavior: reduceMotion() ? "auto" : "smooth" }); }
      if (event.key === "End") { event.preventDefault(); rail.scrollTo({ left: rail.scrollWidth, behavior: reduceMotion() ? "auto" : "smooth" }); }
    });

    // Never translate a vertical wheel gesture into horizontal movement. That
    // made the product rail trap the page whenever the cursor was over a card.
    // Native horizontal trackpad gestures, touch swipes, keys and arrow buttons
    // still move the rail without cancelling the document's vertical scroll.
  });
})();
